import { useNavigate } from 'react-router-dom';

interface Props {
  title: string;
  description: string;
  icon?: string;
}

export const InsightsLockedBlock = ({ title, description, icon = 'ri-lock-line' }: Props) => {
  const navigate = useNavigate();
  return (
    <div className="bg-gray-50 rounded-2xl border border-dashed border-gray-200 px-6 py-8 text-center">
      <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-2xl mx-auto mb-3">
        <i className={`${icon} text-amber-500 text-[22px]`} />
      </div>
      <p className="text-[14px] font-700 text-gray-700 mb-1">{title}</p>
      <p className="text-[12px] text-gray-400 mb-4 max-w-xs mx-auto">{description}</p>
      <button
        onClick={() => navigate('/perfil')}
        className="px-5 py-2.5 bg-amber-500 text-white text-[13px] font-600 rounded-xl hover:bg-amber-600 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-vip-crown-line mr-1.5" />
        Ver planos disponíveis
      </button>
    </div>
  );
};
